import apiInstance from './api';

const userApi = apiInstance.injectEndpoints({
  endpoints: (build) => ({
    getUserList: build.query({
      query: (params) => ({
        url: `/users`,
        params,
      }),
      providesTags: ['UserList'],
    }),
    getUserListInfinite: build.infiniteQuery({
      infiniteQueryOptions: {
        initialPageParam: 1,
        getNextPageParam: (lastPage, allPages, lastPageParam) =>
          lastPage['hydra:member'].length > 0 ? lastPageParam + 1 : undefined,
      },
      query({ queryArg, pageParam }) {
        const { role, search } = queryArg ?? {};
        return {
          url: '/users',
          params: {
            page: pageParam,
            itemsPerPage: 20,
            'order[firstName]': 'asc',
            ...(role && { 'roles[]': role }),
            ...(search && { searchKey: search }),
          },
        };
      },
      providesTags: ['UserList'],
    }),
    getUser: build.query({
      query: (id) => `/users/${id}`,
      providesTags: ['UserList'],
    }),
    getFilteredUserList: build.query({
      query: (params) => ({
        url: `/users/auto_complete`,
        params,
      }),
      transformResponse: (response) => response['hydra:member'],
      providesTags: ['UserAutoComplete'],
    }),
  }),
});

export default userApi;
